import { createSlice } from "@reduxjs/toolkit";
import { getDoctorHomeVisitRequests } from "../../reducer/getDoctorHomeVisit/getDoctorHomeVisitRequestsReducer";

const initialState = {
  data: {},
  isLoading: false,
  error: null,
};

const doctorHomeVisitRequestsSlice = createSlice({
  name: "doctorHomeVisitRequests",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDoctorHomeVisitRequests.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getDoctorHomeVisitRequests.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(getDoctorHomeVisitRequests.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default doctorHomeVisitRequestsSlice.reducer;
